import styled, { css } from 'styled-components';
import { P as PortalComponent } from '../Portal/PortalComponent-BUo03SeR.js';

const TRANSITION_CLASSNAME_PREFIX = 'popper-surface-transition';
const PopoverTrigger = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40027066__sc-4z7sux-0"
})(["display:inline-block;width:", ";"], ({
  $fullWidth
}) => $fullWidth ? '100%' : 'auto');
PopoverTrigger.displayName = 'PopoverTrigger';
const PopoverSurface = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-4z7sux-1"
})(["", ";border-radius:", ";box-shadow:", ";z-index:", ";@media (prefers-reduced-motion:no-preference){transition:opacity ", "ms ease-in-out;}opacity:0;&&.", "-appear{opacity:0;}&&.", "-appear-active{opacity:1;}&&.", "-appear-done{opacity:1;}&&.", "-enter{opacity:1;}&&.", "-enter-active{opacity:1;}&&.", "-enter-done{opacity:1;}&&.", "-exit{opacity:0;}&&.", "-exit-active{opacity:0;}&&.", "-exit-done{opacity:0;}", " > &&{width:max-content;}"], ({
  theme,
  $variant
}) => {
  if ($variant === 'spotlight') {
    return css(["background-color:", ";border:none;"], theme.support.backgroundColor.spotlightBold);
  }
  if ($variant === 'inverted') {
    return css(["background-color:", ";border:none;"], theme.surface.inverted);
  }
  return css(["background-color:", ";border:", ";"], theme.surface.container.default, theme.border.subtle.default);
}, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.elevation.shadow.overlay, ({
  theme
}) => theme.elevation.zIndex.layer3, ({
  $transitionDuration
}) => $transitionDuration, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, /* only apply `width: max-content;` to Popovers that are children of Popovers */
PortalComponent);
PopoverSurface.displayName = 'PopoverSurface';
const PopperArrow = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-4z7sux-2"
})(["position:absolute;width:10px;height:10px;z-index:-1;::after{content:\" \";position:absolute;transform:rotate(45deg);/*! @noflip */ width:10px;height:10px;", ";}*[data-popper-placement^=\"right\"] > &{left:0;/*! @noflip */}*[data-popper-placement^=\"right\"] > &::before{left:-6px;/*! @noflip */}*[data-popper-placement^=\"right\"] > &::after{left:-6px;/*! @noflip */ box-shadow:-1px 1px 2px -1px rgba(35,47,63,0.3);/*! @noflip */ border-left:", ";border-bottom:", ";}*[data-popper-placement^=\"left\"] > &{right:0;/*! @noflip */}*[data-popper-placement^=\"left\"] > &::before{right:-6px;/*! @noflip */}*[data-popper-placement^=\"left\"] > &::after{right:-6px;/*! @noflip */ box-shadow:1px -1px 2px -1px rgba(35,47,63,0.3);/*! @noflip */ border-right:", ";border-top:", ";}*[data-popper-placement^=\"top\"] > &{bottom:0;}*[data-popper-placement^=\"top\"] > &::before{bottom:-6px;}*[data-popper-placement^=\"top\"] > &::after{bottom:-6px;box-shadow:1px 1px 2px -1px rgba(35,47,63,0.3);/*! @noflip */ border-right:", ";border-bottom:", ";}*[data-popper-placement^=\"bottom\"] > &{top:0;}*[data-popper-placement^=\"bottom\"] > &::before{top:-6px;}*[data-popper-placement^=\"bottom\"] > &::after{top:-6px;box-shadow:-1px -1px 2px -1px rgba(35,47,63,0.3);/*! @noflip */ border-left:", ";border-top:", ";}"], ({
  theme,
  $variant
}) => {
  if ($variant === 'spotlight') {
    return css(["background-color:", ";"], theme.support.backgroundColor.spotlightBold);
  }
  if ($variant === 'inverted') {
    return css(["background-color:", ";"], theme.surface.inverted);
  }
  return `background-color: ${theme.surface.container.default}`;
}, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.border.subtle.default);

export { PopoverTrigger as P, TRANSITION_CLASSNAME_PREFIX as T, PopoverSurface as a, PopperArrow as b };
//# sourceMappingURL=Popover.styles-BcziRqke.js.map
